import React from 'react';

const BuilderLogo = ({ logo, alt, isSelected, onClick, className = '' }) => {
    return (
        <div
            className={`w-24 h-24 md:w-40 md:h-40 rounded-full flex items-center justify-center bg-white p-2 md:p-4 shadow-md border overflow-hidden cursor-pointer transition-all duration-300 ${isSelected ? 'border-projectGreen border-6 shadow-lg shadow-projectGreen/30' : 'border-gray-100'} ${className}`}
            onClick={onClick}
        >
            <img src={logo} alt={alt} className="max-w-full h-auto" />
        </div>
    );
};

export default BuilderLogo;